<template>
    <v-card class="array-view" elevation="1">
        <v-data-table
            class="array-view__table"
            item-key="id"
            :headers="tableHeaders"
            :items="items"
            :items-per-page="size"
            :loading="isLoading"
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            :server-items-length="items ? items.length : 0"
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0"
            @update:options="onOptionsChange"
        >
            <template slot="item" slot-scope="props">
                <tr>
                    <td
                        v-for="header in headers"
                        :key="header.value"
                    >
                        <span v-if="header.text === 'categories'"> {{ getCategories(props.item) }}</span>
                        <span v-else-if="header.text === 'League'"> {{ props.item[header.value] !== null ? props.item[header.value].title : '-' }}</span>
                        <span v-else-if="header.text === 'Cup'"> <v-icon :color="props.item['cup'] ? 'green' : 'red'"> {{ props.item['cup'] ? 'mdi-check' : 'mdi-close' }}</v-icon> </span>
                        <span v-else-if="header.value === 'noOfMatches'"> {{ `#MatchesRule${props.item[header.value].slice(-1)}` }}</span>
                        <span v-else-if="header.text === 'Free'"> <v-icon :color="props.item[header.value] ? 'green' : 'red'"> {{ props.item[header.value] ? 'mdi-check' : 'mdi-close' }} </v-icon> </span>
                        <span v-else-if="header.text === 'Image' || header.text === 'History Points Icon Image'"> <v-img contain width="200px" height="100px" :src="props.item[header.value]" /></span>
                        <v-chip
                            v-else-if="header.chip && header.chip(props.item)"
                            x-small
                            dark
                            :color="header.chip(props.item).color"
                            :title="header.chip(props.item).title"
                        >
                            <v-icon v-if="header.chip(props.item).icon" x-small left>{{ header.chip(props.item).icon }}</v-icon>{{ header.chip(props.item).text }}
                        </v-chip>
                        <span v-else-if="header.chip" class="grey--text">–</span>
                        <v-chip v-else-if="type === 'teamApplication' && header.value === 'status'" x-small dark :color="statusColors[props.item.status]">{{ props.item.status }}</v-chip>
                        <span v-else-if="header.text.includes('Date')"> {{ getDate(props.item[header.value], type === 'match') }}</span>
                        <v-icon v-else-if="typeof props.item[header.value] === 'boolean'" small :color="props.item[header.value] ? 'green' : 'red'">
                            {{ props.item[header.value] ? 'mdi-check-circle' : 'mdi-close-circle' }}
                        </v-icon>
                        <span v-else>{{ header.subLevel ? (props.item[header.value] ? props.item[header.value][header.subLevel] : '-') : props.item[header.value] }}</span>
                    </td>
                    <td v-if="!hideActions || deleteAction" class="text-right actions-cell">
                        <v-tooltip v-if="type === 'match'" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small v-bind="attrs" v-on="on" @click="$router.push( `/stats/match/${props.item.id}`)">
                                    <v-icon small>mdi-chart-bar</v-icon>
                                </v-btn>
                            </template>
                            <span>Stats</span>
                        </v-tooltip>
                        <!-- the scoresheet, once the match has a score -->
                        <v-tooltip v-if="type === 'match' && (props.item.scoreTeam1 || props.item.scoreTeam2)" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small v-bind="attrs" v-on="on" @click="openSheet(props.item)">
                                    <v-icon small>mdi-clipboard-text-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>Φύλλο αγώνα</span>
                        </v-tooltip>
                        <!-- extra buttons of the page, before Edit -->
                        <slot name="row-actions" :item="props.item" />
                        <v-tooltip v-if="!hideActions" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small v-bind="attrs" v-on="on" @click="handleClick('edit', props.item)">
                                    <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                            <span>Edit</span>
                        </v-tooltip>
                        <delete-button :type="false" color="red darken-1" @delete-entry="onDelete(props.item, localPage)" />
                    </td>
                </tr>
            </template>
        </v-data-table>
        <custom-dialog :dialog="showDialog" @update="showDialog = !showDialog" />
        <match-sheet v-if="type === 'match'" v-model="sheetOpen" :match-id="sheetMatchId" />
        <div v-if="totalPages" class="array-view__footer">
            <v-pagination
                v-model="localPage"
                class="array-view__pagination"
                :length="totalPages"
                total-visible="7"
                color="black"
                circle
                @input="paginationChange"
            />
            <div class="array-view__size">
                <span class="text-caption grey--text text--darken-1 mr-2">Rows per page</span>
                <v-select
                    v-model="localSize"
                    :items="sizes"
                    outlined
                    dense
                    hide-details
                    return-object
                    @input="sizeChange"
                />
            </div>
        </div>
    </v-card>
</template>

<script>
    import CustomDialog from '@/components/Dialog'
    import momentTimezone from 'moment-timezone'
    import DeleteButton from '@/components/DeleteButton'
    import MatchSheet from '@/components/MatchSheet'

    export default {
        components: { CustomDialog, DeleteButton, MatchSheet },
        props: {
            items: {
                type: Array,
                default: null
            },
            headers: {
                type: Array,
                default: null
            },
            totalPages: {
                type: Number,
                default: null
            },
            page: {
                type: Number,
                default: null
            },
            size: {
                type: Number,
                default: null
            },
            type: {
                type: String,
                default: null
            },
            hideActions: {
                type: Boolean,
                default: false
            },
            deleteAction: {
                type: Boolean,
                default: false
            },
            // server-side sort; ArrayView only emits sortChange, the parent refetches
            sortBy: {
                type: String,
                default: null
            },
            sortDesc: {
                type: Boolean,
                default: false
            }
        },
        data: () => {
            return {
                localPage: 1,
                localSize: 10,
                sizes: [5, 10, 30, 60, 100],
                message: 'Please verify your ',
                role: '',
                showDialog: false,
                sheetOpen: false,
                sheetMatchId: null,
                images: [
                    { url: 'https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/852099ce-b105-48e4-b97a-5b6fd14d7ddf/%CE%B1%CE%BD%CE%B4%CF%81%CE%B9%CE%BA%CE%BF-%CF%80%CE%B1%CF%80%CE%BF%CF%85%CF%84%CF%83%CE%B9-air-max-270-fFBpMM.png' },
                    { url: 'https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/20784a41-1187-4979-af37-64eea1843fd6/%CE%B1%CE%BD%CE%B4%CF%81%CE%B9%CE%BA%CE%BF-%CF%80%CE%B1%CF%80%CE%BF%CF%85%CF%84%CF%83%CE%B9-air-max-270-fFBpMM.png' },
                    { url: 'https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/fa3de888-3106-4f49-a1a0-53f3e6864bf6/%CE%B1%CE%BD%CE%B4%CF%81%CE%B9%CE%BA%CE%BF-%CF%80%CE%B1%CF%80%CE%BF%CF%85%CF%84%CF%83%CE%B9-air-max-270-fFBpMM.png' },
                    { url: 'https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5,q_80/e46d4b68-5974-4781-b5f9-f317c50f87b6/%CE%B1%CE%BD%CE%B4%CF%81%CE%B9%CE%BA%CE%BF-%CF%80%CE%B1%CF%80%CE%BF%CF%85%CF%84%CF%83%CE%B9-air-max-270-fFBpMM.png' },
                    { url: 'https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/852099ce-b105-48e4-b97a-5b6fd14d7ddf/%CE%B1%CE%BD%CE%B4%CF%81%CE%B9%CE%BA%CE%BF-%CF%80%CE%B1%CF%80%CE%BF%CF%85%CF%84%CF%83%CE%B9-air-max-270-fFBpMM.png' }
                ],
                actionsHeader: [
                    {
                        text: '',
                        value: 'actions',
                        sortable: false,
                        align: 'end'
                    }
                ],
                statusColors: { pending: 'orange', accepted: 'green', rejected: 'red' },
                isLoading: true
            }
        },
        computed: {
            tableHeaders() {
                // nested columns (team.name etc.) are not sortable: the backend combines DISTINCT with the sort
                const headers = this.headers.map(header => ({
                    ...header,
                    sortable: header.sortable !== false && !header.subLevel
                }))
                return this.hideActions && !this.deleteAction ? headers : headers.concat(this.actionsHeader)
            }
        },
        watch: {
            items() {
                if (Array.isArray(this.items)) {
                    this.isLoading = false
                }
            },
            page() {
                this.localPage = this.page
            }
        },
        created() {
            this.localPage = this.page
            this.localSize = this.size
        },
        methods: {
            openSheet(item) {
                this.sheetMatchId = item.id
                this.sheetOpen = true
            },
            onDelete(item, page, parent) {
                this.$emit('onDelete', item, page, parent)
            },
            onOptionsChange(options) {
                const sortBy = options.sortBy.length ? options.sortBy[0] : null
                const sortDesc = sortBy ? !!options.sortDesc[0] : false
                if (sortBy !== this.sortBy || sortDesc !== this.sortDesc) {
                    this.$emit('sortChange', { sortBy, sortDesc })
                }
            },
            handleClick(action, item) {
                this.$emit('handleClick', action, item)
            },
            paginationChange() {
                this.$emit('paginationChange', this.localPage, this.localSize)
            },
            sizeChange() {
                this.localPage = 1
                this.paginationChange()
            },
            getCategories(item) {
                let categories = []
                item.categories.forEach(element => { categories.push(element.alias) })
                return categories.join(', ')
            },
            getDate(date, isMatch) {
                return isMatch ? momentTimezone(date).tz('Europe/Athens').format('DD/MM/YYYY HH:mm').toString() : momentTimezone(date).tz('Europe/Athens').format('DD/MM/YYYY').toString()
            }
        }
    }
</script>

<style scoped>
    .array-view__table ::v-deep th {
        white-space: nowrap;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.7) !important;
        background: #fafafa;
    }

    .array-view__table ::v-deep tbody tr:hover {
        background: #fff8ec !important;
    }

    .actions-cell {
        white-space: nowrap;
        width: 1%;
    }

    .array-view__footer {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 8px 24px;
        padding: 8px 16px;
        border-top: 1px solid rgba(0, 0, 0, 0.08);
    }

    .array-view__pagination {
        flex: 1 1 auto;
    }

    .array-view__size {
        display: flex;
        align-items: center;
    }

    .array-view__size .v-select {
        width: 90px;
    }
</style>
